import { Route } from "react-router";
import { AuthWrapper } from "./index";
import { AuthInnerRoutes } from "../types";
import { routeData } from "./constants";

export const AuthRoute = (path: AuthInnerRoutes) => {
  return (
    <Route
      path={path}
      key={path}
      element={
        <AuthWrapper pageType={routeData[path].pageType}>
          {routeData[path].component}
        </AuthWrapper>
      }
    />
  );
};
